<template>
    <div class="contact_us premium">
        <article>
            <header class="formula" :class="formuleClass" v-if="header">
                <div class="edging" :class="formuleClass"></div>
                <slot name="header">
                    <span>{{formuleLabel}}</span>
                </slot>
            </header>
            
                <div class="content">
                    <slot name="body">
                        <h2>Découvrez votre taux personnalisé</h2>
                        <p>Nous avons besoin de plus d’informations pour pouvoir calculer votre taux de success fees.</p>
                        <p>Merci de remplir les informations suivantes, nos équipes seront ravies d’échanger avec vous.</p>                                        
                    </slot>
                    <div v-if="cta">
                      <input id="rsoc" type="text" placeholder="Nom ou raison sociale" v-model="raisonSocial">
                      <input id="tel" type="tel" placeholder="Numéro de téléphone" v-model="telephone">
                      <button :class="formuleClass" @click="toBeContacted()" :disabled="raisonSocial=='' || telephone==''">Être contacté</button>
                    </div>
                    <div v-if="!cta && closeButton">
                      <button :class="formuleClass" @click="$emit('contact')">Fermer</button>
                    </div>
                </div>            
        </article>
        <img v-if="illustration" class="illustration" src="/assets/img/Contact_us_cmn.svg">
    </div>
</template>

<script>

import NotificationAPI from '../../api/notifications';
import googleTagManagerPushEventToDataLayer from "../../../site/helpers/gtm";

export default {
    name: 'to-be-contacted',
    data() {
        return {
            raisonSocial : this.professional.company,
            telephone: this.professional.tel,
            notificationApi : new NotificationAPI()
        }
    },
    props: {
        professional : Object,
        plan: [Object,null],
        illustration: {
            type: Boolean,
            default: true
        },
        header: {
            type: Boolean,
            default: true
        },
        cta : {
          type: Boolean,
          default: true
        },
        closeButton: {
          type: Boolean,
          default: true
        }
    },
    computed: {
        formuleClass() {
            return this.plan!=null && this.plan.id == 'new-premium-plus' ? 'premium-plus' : 'premium';
        },
        formuleLabel() {
            return this.plan!=null && this.plan.id == 'new-premium-plus' ? 'FORMULE RENDEZ-VOUS MANDATS' : 'FORMULE PREMIUM';
        },
    },
    methods: {
        toBeContacted() {            
            this.notificationApi.toBeContacted(this.professional.id,{
                rsoc: this.raisonSocial,
                tel: this.telephone,
            })
            .then((response) => {                
                this.raisonSocial='';
                this.telephone='';                
                this.$swal({
                    type: "success",
                    title: "Merci !",
                    text: 'Notre équipe va rapidement prendre contact avec vous.'
                });              
                this.$emit('contact');
                

                googleTagManagerPushEventToDataLayer({
                    event: 'subscription-contact',
                    eventCategory: 'Subscription Contact',
                    eventAction: 'Subscription Contact Success',
                    eventLabel: this.formuleLabel,
                    eventValue: undefined,
                })
            })
            .catch((response) => {
                this.$swal({
                    type: 'error',
                    title: 'Erreur',
                    text: 'Une erreur est survenue lors de votre demande. Veuillez contacter notre équipe.',
                });
            })            
        }
    },
}
</script>

<style lang="sass">

    $light-premium-color: #EBC158
    $base-premium-color: #CD7E5D
    $light-premium-plus-color: #FEECCF
    $base-premium-plus-color: #FBC167

    ::placeholder
        color: #DADADA

    .contact_us
        display: flex
        flex-direction: row
        font-family: Roboto
        font-style: normal
        font-weight: 500
        font-size: 20px
        justify-content: center
        margin-top: 5%
        margin-top: 5%
        margin-bottom: 5%

        article
            max-width: 450px

            .formula
                display: flex
                flex-direction: row
                margin-bottom: 5%

                @media (max-width: 1025px)
                    justify-content: center


                &.premium
                    color: $base-premium-color
                &.premium-plus
                    color: $base-premium-plus-color

                .edging
                    width: 30px
                    height: 5px
                    transform: rotate(90deg)
                    margin-top: 10px
                    margin-left: -13px

                    &.premium
                        background: linear-gradient(90deg,$light-premium-color 0%,$base-premium-color 100%)
                    &.premium-plus
                        background: linear-gradient(90deg,$light-premium-plus-color 0%,$base-premium-plus-color 100%)

                    @media (max-width: 1025px)
                        display: none

            .content
                max-width: 350px
                display: flex
                flex-direction: column
                text-align: justify

                @media (max-width: 1025px)
                    text-align: center


                h2
                    font-weight: bold
                    font-size: 16px
                    color: #4A4A4A
                    margin-bottom: 1em

                p
                    font-size: 16px
                    font-weight: normal
                    color: #2A2A2A
                    line-height: 100%
                    margin-bottom: 1em

                input
                    font-family: 'Noto Sans JP', sans-serif
                    font-weight: 500
                    font-size: 14px
                    border: 1px solid #DADADA
                    box-sizing: border-box
                    border-radius: 3px
                    width: 100%
                    height: 36px
                    margin-top: 18px
                    padding: 4px

                button
                    border-radius: 31px
                    border: none
                    height: 50px
                    width: 100%
                    margin-top: 30px
                    font-family: 'Noto Sans JP', sans-serif
                    font-style: normal
                    font-weight: bold
                    font-size: 16px
                    color: white
                    cursor: pointer

                    &:disabled
                        opacity: 0.5

                    &:hover,
                    &:focus
                        opacity: .875 // replace with best hover/focus effects


                    &.premium
                        background: linear-gradient(180deg,$light-premium-color 0%,$base-premium-color 100%)
                    &.premium-plus
                        background: linear-gradient(180deg,$light-premium-plus-color 0%,$base-premium-plus-color 100%)




        img
            width: 450px
            height: 450px

            @media (max-width: 1025px)
                display: none


</style>



// WEBPACK FOOTER //
// application/assets/js/professional/containers/Subscriptions/ToBeContacted.vue